module.exports = __webpack_public_path__ + "static/img/mission-modular-2.4d5d3832.png";